import { FORM_MODES } from 'config/formModes';
import { BASE_FORM_ROUTE_PATH, FORM_MODE_TO_PATH_MAP } from '../../../../config/routes';
import { replacePathParams } from '../../../campaigns/services/utils';
import { ACCOUNT_ID_PARAM_TEMPLATE, PUSH_API_ID_PARAM_TEMPLATE } from './account';
import { ENTITY, ENTITY_TO_PATH_MAP } from './entity';

const KEY_TO_PATH_MAP_MAP = {
    mode: FORM_MODE_TO_PATH_MAP,
    entity: ENTITY_TO_PATH_MAP,
};

export const PUSH_API_ROUTE_PATH = `${BASE_FORM_ROUTE_PATH}${ACCOUNT_ID_PARAM_TEMPLATE}${PUSH_API_ID_PARAM_TEMPLATE}`;

export const PUSH_API_CREATOR_ROUTE_PATH = replacePathParams(
    PUSH_API_ROUTE_PATH,
    {
        entity: [ENTITY.PUSH_API],
        mode: [FORM_MODES.CREATE],
    },
    [],
    KEY_TO_PATH_MAP_MAP
);

export const PUSH_API_EDIT_ROUTE_PATH = replacePathParams(
    PUSH_API_ROUTE_PATH,
    {
        entity: [ENTITY.PUSH_API],
        mode: [FORM_MODES.EDIT],
    },
    ['subscriptionId'],
    KEY_TO_PATH_MAP_MAP
);
